﻿import buttonLoader from '../utilities/buttonLoader.js';

var standardForm = {};

standardForm = {

  init: function () {
    var me = this;
    var form = document.getElementsByClassName('formStandard')[0];

    if (form) {
      me.bind(form);
    }

    var formNoRecaptcha = document.getElementsByClassName('formStandard--norecaptcha')[0];

    if (formNoRecaptcha) {
      me.bind(formNoRecaptcha);
    }
  },

  bind: function (form) {
    var me = this;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var m = form.querySelector('.alert');

      if (m) {
        m.remove();
      }

      me.submit(form);

    });
  },

  submit: function (form) {
    var me = this;
    var button = form.querySelector('button[type=submit]');

    if (me.validateRecaptcha(form)) {
      
      buttonLoader.start(button);

      var data = new FormData(form);

      var xhr = new XMLHttpRequest();
      xhr.open(form.getAttribute("method"), form.getAttribute("action"));
      //xhr.setRequestHeader("Content-Type", "multipart/form-data");

      xhr.onload = function() {

        var resp = JSON.parse(xhr.response);

        if (xhr.status >= 200 && xhr.status < 300) {

          if (resp.success) {

            if (resp.redirect) {
              window.location.replace(resp.redirect);
            } else {
              form.reset();

              buttonLoader.success(button);

              me.renderMessage(button, resp.message, 'success');
            }

          } else {

            buttonLoader.reset(button);

            me.renderMessage(button, resp.message, 'error');
          }

        } else {

          buttonLoader.reset(button);

          me.renderMessage(button, 'Server error', 'error');
        }

        //grecaptcha.reset();

      };

      xhr.send(data);

    } else {
      me.renderMessage(button, 'Ekki hefur verið fyllt út í vélmenna vörn.', 'error');
    }


  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  },

  validateRecaptcha: function (form) {

    if (form.classList.contains('formStandard--norecaptcha')) {
      return true;
    }

    var v = grecaptcha.getResponse();

    if (v.length === 0) {

      return false;
    }

    return true;
  }

};

standardForm.initialize = function () {
  standardForm.init();
};

module.exports = standardForm;
